export const cdgiHighlights = [
   "NAAC A+ Accredited & AICTE Approved",
  "Modern Curriculum with AI, Cloud, and DevOps",
  "Research & Innovation Labs for Data and Cybersecurity",
  "Strong Placement Network with 100+ Top Recruiters",
  "Faculty with Academic & Industry Experience",
  "Regular Coding Bootcamps and Workshops",
  "Internship Tie-ups with Leading IT Firms"
];

export  const keyLearningAreas = [
  "Software Engineering & Web Technologies",
  "Network Administration & Security",
  "Database Systems & Data Mining",
  "Operating Systems & Cloud Computing",
  "Programming in Java, Python, C++",
  "System Analysis and Design",
  "Artificial Intelligence & Automation"
];

export const labFacilities = [
  "Software Development Lab",
  "Networking & Security Lab",
  "Cloud Infrastructure Lab",
  "Web Technologies Lab",
  "Data Analytics Lab"
];

export const careerOpportunities = [
  "Software Engineer",
  "IT Analyst",
  "Systems Administrator",
  "Cybersecurity Specialist",
  "Cloud Engineer",
  "DevOps Professional",
  "Web and App Developer",
  "Data Analyst / Business Intelligence Expert"
];

export const placementCompanies = [
  "Infosys",
  "TCS",
  "Wipro",
  "HCL",
  "Tech Mahindra",
  "Capgemini",
  "IBM",
  "Cognizant"
];


export const prePlacementTraining = [
  "Mock Interviews & Group Discussions",
  "Coding Assessments",
  "Resume Writing & LinkedIn Profiling",
  "Soft Skills & Communication Workshops",
  "Corporate Guest Lectures & Industrial Visits"
];

export const facultyAndMentorship = [
  "Project-Based Learning",
  "Research Paper Writing & Presentations",
  "Patent Filing & Prototyping",
  "Technical Skill Certifications"
];

export  const studentLife = [
  "Tech Clubs: Cyber Cell, App Dev Club, Data Analytics Forum",
  "Intra & Inter-College Coding Competitions",
  "Annual Tech Fest “Techspirits”",
  "Hackathons and Project Showcases",
  "Sports, Cultural Events & Hostel Life"
];


export const researchAndDevelopment = [
"Student-led Research Projects",
"Funded Grants from AICTE, MSME",
"Collaborative Research with Faculty",
"Publication in National & International Journals" 
]


export const globalCertifications = [
"Microsoft Azure / AWS Cloud Certification",
"Red Hat Linux / Cisco Networking",
"Google Data Analytics / Python for Everyone",
"GitHub Portfolio & CI/CD Tools Training"
]


export const cdgiFAQs = [
  {
    index: 1,
    question: "Is CDGI a good choice for B.Tech in Information Technology?",
    answer: "Yes, CDGI is NAAC A+ accredited and offers one of the most industry-relevant IT programs in Madhya Pradesh."
  },
  {
    index: 2,
    question: "What is the placement record for IT students?",
    answer: "CDGI has consistent placement records with top tech companies offering roles in development, support, and analytics."
  },
  {
    index: 3,
    question: "Are there research opportunities?",
    answer: "Yes, CDGI actively supports research through labs, grants, and mentorship."
  },
  {
    index: 4,
    question: "What certifications are available?",
    answer: "Students can earn certifications in Cloud, Cybersecurity, Linux, and Data Science."
  },
  {
    index: 5,
    question: "What makes CDGI the best information technology engineering college?",
    answer: "Our curriculum, placement support, faculty, and focus on innovation make us a preferred destination for aspiring IT professionals."
  }
];
